import { useCallback } from 'react';
import type { GridFilterModel } from '@mui/x-data-grid';
import {
  usePagination,
  type UsePaginationOptions,
} from '../../../shared/hooks/usePagination';

const DIAM_GRID_DEFAULTS: UsePaginationOptions = {
  initialPageSize: 20,
  initialPage: 0,
  initialSortField: 'createdAt',
  initialSortOrder: 'desc',
};

export function useDiamGridPagination(options: UsePaginationOptions = {}) {
  const { handleFilterModelChange, handlePagination, pageSize, ...pagination } =
    usePagination({
      ...DIAM_GRID_DEFAULTS,
      ...options,
    });

  const handleServerFilterModelChange = useCallback(
    (model: GridFilterModel) => {
      handleFilterModelChange(model);
      handlePagination({ page: 0, pageSize });
    },
    [handleFilterModelChange, handlePagination, pageSize],
  );

  return {
    ...pagination,
    pageSize,
    handleFilterModelChange,
    handlePagination,
    handleServerFilterModelChange,
  };
}
